/**
 * 功能开关路由守卫
 *
 * 包裹在功能页面外层，当功能开关关闭时自动展示"暂未开放"占位页。
 */

import { type ReactNode } from 'react';
import { useFeatureFlags } from '../hooks/useFeatureFlags';
import { FeatureDisabledPage } from './FeatureDisabledPage';
import type { PublicFeatureFlags } from '../services/api';

interface FeatureGuardProps {
  /** 对应 PublicFeatureFlags 中的字段名 */
  feature: keyof Omit<PublicFeatureFlags, 'isAdmin'>;
  /** 功能中文名称（用于占位页展示） */
  featureName: string;
  /** 子组件（功能页面） */
  children: ReactNode;
}

export function FeatureGuard({ feature, featureName, children }: FeatureGuardProps) {
  const { isEnabled, loaded } = useFeatureFlags();

  // 未加载完成时不闪烁（默认全开，加载后再决定）
  if (!loaded) return null;

  if (!isEnabled(feature)) {
    return <FeatureDisabledPage featureName={featureName} />;
  }

  return <>{children}</>;
}
